import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

// Hiện lý do thật thay vì câu chung chung, để người dùng chụp màn hình gửi lại là biết lỗi gì
const describeError = (error) => {
  const res = error?.response;
  if (!res) {
    if (error?.code === 'ECONNABORTED')
      return 'Máy chủ phản hồi quá lâu (quá thời gian chờ). Vui lòng thử lại hoặc thu hẹp khoảng ngày.';
    return 'Không kết nối được tới máy chủ. Vui lòng kiểm tra mạng và thử lại.';
  }
  const message = res.data?.status?.message || res.data?.message || res.data?.error_description;
  if (message) return `${message} (HTTP ${res.status})`;
  if (res.status === 401) return 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại. (HTTP 401)';
  if (res.status === 403) return 'Tài khoản không có quyền xem dữ liệu này. (HTTP 403)';
  return `Bạn vui lòng liên hệ Admin để được hỗ trợ. (HTTP ${res.status})`;
};

export default ({ error, loading }) => {
  if (loading)
    return (
      <Container maxWidth="md">
        <Box display="flex" justifyContent="space-around">
          <CircularProgress size={30} />
        </Box>
      </Container>
    );
  if (error) {
    return (
      <Container maxWidth="md">
        <Alert severity="error">
          <AlertTitle>Có lỗi xảy ra!</AlertTitle>
          {describeError(error)}
        </Alert>
      </Container>
    );
  }
  return <div />;
};
